import { __ } from '../../utilities';
import { rem } from 'polished';
import Icon from '../../components/Icon';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import moment from 'moment';
import styled from 'styled-components';

const ShareButton = styled.div`
  width: ${rem(12)};
`;

const Wrapper = styled.div`
  position: absolute;
  height: 100%;
  background: #fff;
  z-index: 5;
  top: 0;
  transition: all 0.3s;
  width: ${rem(280)};

  left: ${({ visible }) => (visible ? '0' : '-100%')};
`;

const IconWrapper = styled.div`
  padding: ${rem(20)};
  cursor: pointer;
`;

const CloseIcon = styled(Icon)`
  display: flex;
  width: ${rem(16)};
  margin-left: auto;
`;

const Heading = styled.div`
  font-size: ${rem(14)};
  font-weight: bold;
  color: ${({ theme }) => theme.color.textColorPrimary};
  margin-bottom: ${rem(30)};
`;

const Content = styled.div`
  padding: ${rem(20)};
`;

const ListWrapper = styled.ul`
  padding: 0;
`;

const List = styled.li`
  list-style-type: none;
  margin-bottom: ${rem(23)};
  font-size: ${rem(14)};
  color: ${({ theme }) => theme.color.textColorPrimary};
  ${({ theme }) => theme.media.sm`
    margin-bottom: ${rem(30)};
  `};
`;

const CheckIcon = styled(Icon)`
  display: none;
  position: absolute;
  left: ${rem(2)};
`;

const Input = styled.input`
  appearance: none; /* eslint-disable-line */
  width: ${rem(16)};
  height: ${rem(16)};
  margin: 0 ${rem(10)} 0 0;
  border-radius: ${rem(2)};
  border: ${rem(2)} solid ${({ color }) => color};

  &:focus {
    outline: 0;
  }

  &:checked {
    border: 0;
    background-color: ${({ color }) => color};
  }

  &:checked + ${CheckIcon} {
    display: flex;
    align-items: center;
  }
`;

const Span = styled.span``;

const Label = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  justify-content: space-between;
`;

class NavSidebar extends PureComponent {
  state = {
    copiedId: null,
  };

  timer = () => {};
  renderCalendar = (calendar) => {
    const { _id, calendarId, name, color } = calendar;
    const { selectedCalendars, onClickCalendar, appspace } = this.props;
    return (
      <List key={_id}>
        <Label
          htmlFor={name}
          onClick={(e) => {
            if (this.state.copiedId === _id) {
              e.preventDefault();
            }
          }}
        >
          <div
            style={{
              overflow: 'hidden',
              position: 'relative',
              width: '90%',
              height: '17px',
            }}
          >
            <div
              style={{
                width: '200%',
                position: 'absolute',
                height: '100%',
                display: 'flex',
                left: this.state.copiedId === _id ? '0' : '-100%',
                transition: '0.2s linear all',
              }}
            >
              <div
                style={{
                  width: '100%',
                  color: '#9e9e9e',
                }}
              >
                {__('Odkaz na iCalendar skopírovaný')}
              </div>
              <div
                style={{ display: 'flex', width: '100%', position: 'relative' }}
              >
                <Input
                  checked={selectedCalendars.indexOf(calendarId) !== -1}
                  type="checkbox"
                  id={name}
                  color={color}
                  onChange={() => onClickCalendar(calendarId)}
                />
                <CheckIcon name="check" color="#fff" width={12} />
                <Span>{name}</Span>
                <input
                  style={{ position: 'fixed', top: '-5000px', left: '-5000px' }}
                  id={`calendar_${_id}`}
                  contentEditable
                  value={`${
                    process.env.REACT_APP_API_BASE_URL
                  }/public/${appspace}/export/events?calendarId=${calendarId}&dateFrom=${moment().format(
                    'YYYY-MM-DD',
                  )}`}
                />
              </div>
            </div>
          </div>
          <ShareButton
            onClick={(e) => {
              e.preventDefault();
              this.props.onClickShareCalendar(calendar);
            }}
          >
            <svg
              key="share"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 19 19"
            >
              <g id="surface1">
                <path
                  fill="#555"
                  d="M 14.15625 0.191406 C 12.910156 0.191406 11.742188 0.675781 10.863281 1.554688 L 7.371094 5.042969 C 6.492188 5.921875 6.007812 7.09375 6.007812 8.335938 C 6.007812 9.925781 6.808594 11.390625 8.15625 12.253906 C 8.359375 12.386719 8.59375 12.421875 8.816406 12.371094 C 9.03125 12.324219 9.230469 12.195312 9.359375 11.992188 C 9.492188 11.789062 9.527344 11.554688 9.480469 11.335938 C 9.429688 11.117188 9.300781 10.917969 9.097656 10.785156 C 8.253906 10.246094 7.753906 9.332031 7.753906 8.335938 C 7.753906 7.558594 8.054688 6.832031 8.605469 6.28125 L 12.097656 2.792969 C 12.644531 2.242188 13.378906 1.9375 14.15625 1.9375 C 15.757812 1.9375 17.0625 3.242188 17.0625 4.847656 C 17.0625 5.625 16.761719 6.355469 16.210938 6.90625 L 14.554688 8.5625 C 14.382812 8.734375 14.296875 8.964844 14.300781 9.195312 C 14.304688 9.414062 14.390625 9.628906 14.554688 9.792969 C 14.726562 9.964844 14.949219 10.050781 15.171875 10.050781 C 15.398438 10.050781 15.621094 9.964844 15.789062 9.792969 L 17.449219 8.136719 C 18.324219 7.257812 18.808594 6.085938 18.808594 4.84375 C 18.808594 2.277344 16.722656 0.191406 14.15625 0.191406 Z M 10.84375 6.746094 C 10.640625 6.613281 10.402344 6.578125 10.183594 6.628906 C 9.96875 6.675781 9.769531 6.804688 9.640625 7.007812 C 9.507812 7.210938 9.472656 7.445312 9.519531 7.664062 C 9.570312 7.882812 9.699219 8.082031 9.902344 8.214844 C 10.746094 8.753906 11.246094 9.667969 11.246094 10.664062 C 11.246094 11.441406 10.945312 12.167969 10.394531 12.71875 L 6.902344 16.210938 C 6.355469 16.761719 5.621094 17.0625 4.84375 17.0625 C 3.242188 17.0625 1.9375 15.757812 1.9375 14.15625 C 1.9375 13.378906 2.238281 12.648438 2.789062 12.097656 L 4.445312 10.441406 C 4.617188 10.265625 4.703125 10.035156 4.699219 9.808594 C 4.695312 9.589844 4.609375 9.371094 4.445312 9.207031 C 4.273438 9.035156 4.050781 8.953125 3.828125 8.953125 C 3.601562 8.953125 3.378906 9.039062 3.210938 9.207031 L 1.550781 10.863281 C 0.675781 11.742188 0.191406 12.910156 0.191406 14.15625 C 0.191406 16.722656 2.277344 18.808594 4.84375 18.808594 C 6.089844 18.808594 7.257812 18.324219 8.136719 17.445312 L 11.628906 13.957031 C 12.507812 13.078125 12.992188 11.90625 12.992188 10.664062 C 12.992188 9.074219 12.1875 7.609375 10.84375 6.746094 Z M 10.84375 6.746094 "
                />
              </g>
            </svg>
          </ShareButton>
        </Label>
      </List>
    );
  };
  renderCalendars = (_) => {
    const { calendars, calendarGroups, onClickCheckAll } = this.props;
    if (calendars.find((c) => c.group)) {
      const calendarsWithoutGroup = calendars.reduce((acc, next) => {
        if (!next.group) {
          return [...acc, next];
        }
        return acc;
      }, []);
      return (
        <Content>
          {calendarGroups.map((group) => {
            const calendarsInGroup = calendars.reduce((acc, next) => {
              if (next.group === group) {
                return [...acc, next];
              }
              return acc;
            }, []);
            if (calendarsInGroup.length > 0) {
              return (
                <React.Fragment key={`${group}`}>
                  <Heading>{group}</Heading>
                  <ListWrapper>
                    {calendarsInGroup.map((c) => this.renderCalendar(c))}
                  </ListWrapper>
                </React.Fragment>
              );
            }
            return [];
          })}
          {calendarsWithoutGroup.length > 0 && (
            <React.Fragment>
              <Heading>{__('Ostatné')}</Heading>
              <ListWrapper>
                {calendarsWithoutGroup.map((c) => this.renderCalendar(c))}
              </ListWrapper>
            </React.Fragment>
          )}
        </Content>
      );
    }

    return (
      <Content>
        <Heading>{__('Kalendáre')}</Heading>
        <List>
          <Label style={{ justifyContent: 'left' }}>
            <Input
              checked={
                this.props.calendars.length ===
                this.props.selectedCalendars.length
              }
              type="checkbox"
              color="#000"
              onChange={onClickCheckAll}
            />
            <CheckIcon name="check" color="#fff" width={12} />
            <Span>{__('Označiť všetky')}</Span>
          </Label>
        </List>
        <ListWrapper>
          {calendars.map((c) => this.renderCalendar(c, calendars.length))}
        </ListWrapper>
      </Content>
    );
  };
  render() {
    const { visible, onClose, isFullScreen } = this.props;

    return (
      <Wrapper visible={visible} isFullScreen={isFullScreen}>
        <IconWrapper onClick={onClose}>
          <CloseIcon name="close" />
        </IconWrapper>
        {this.renderCalendars()}
      </Wrapper>
    );
  }
}

NavSidebar.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onClickCalendar: PropTypes.func.isRequired,
  onClickCheckAll: PropTypes.func.isRequired,
  calendars: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      color: PropTypes.string,
      name: PropTypes.string,
    }),
  ).isRequired,
  selectedCalendars: PropTypes.arrayOf(PropTypes.string),
  isFullScreen: PropTypes.bool.isRequired,
  calendarGroups: PropTypes.arrayOf(PropTypes.string).isRequired,
  appspace: PropTypes.string.isRequired,
  onClickShareCalendar: PropTypes.func.isRequired,
};

NavSidebar.defaultProps = {
  selectedCalendars: [],
};

export default NavSidebar;
